import { useConfirmDialog } from "../ConfirmDialog";

export const useDeleteColumn = () => {
	const { confirm } = useConfirmDialog();

	const deleteColumnConfirmation = ({ columnName }: { columnName: string }) => {
		return confirm({
			headingTitle: "Delete column",
			content: (
				<>
					<strong>
						Permanently delete all the data in column '<code>{columnName}</code>'?
					</strong>{" "}
					This action cannot be reversed.
				</>
			),
			variant: "negative",
			confirmLabel: "Delete column",
		});
	};

	return deleteColumnConfirmation;
};
